"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.highLightSearcher = void 0;
const replaceAll_1 = require("./replaceAll");
const highLightSearcher = ({ searcherList, origin, test, }) => {
    let result = {
        value: "",
        originMatcher: [],
    };
    if (!searcherList)
        return result;
    const originUpper = origin.toUpperCase();
    const findIndexMark = searcherList.map((temp, idx) => {
        if (temp.trim() === "") {
            return {
                searcher: temp,
                originStr: "",
                indexPair: [],
                isMark: false,
            };
        }
        const tempUpper = temp.trim().toUpperCase();
        if (originUpper.includes(tempUpper)) {
            const originObj = new String(originUpper);
            if (originObj.indexOf(tempUpper) > -1) {
                return {
                    searcher: temp,
                    originStr: origin.slice(originObj.indexOf(tempUpper), originObj.indexOf(tempUpper) + temp.length),
                    indexPair: [
                        originObj.indexOf(tempUpper),
                        originObj.indexOf(tempUpper) + temp.length,
                    ],
                    isMark: true,
                };
            }
        }
        return {
            searcher: temp,
            originStr: "",
            indexPair: [],
            isMark: false,
        };
    });
    findIndexMark.forEach((temp3) => {
        if (temp3.isMark) {
            if (result.value) {
                result = {
                    value: (0, replaceAll_1.replaceAll)(result.value, temp3.originStr, `_${temp3.originStr}_`),
                    originMatcher: [...result.originMatcher, temp3.originStr],
                };
            }
            if (!result.value) {
                result = {
                    value: (0, replaceAll_1.replaceAll)(origin, temp3.originStr, `_${temp3.originStr}_`),
                    originMatcher: [temp3.originStr],
                };
            }
        }
    });
    return result;
};
exports.highLightSearcher = highLightSearcher;
